export interface ErrorMessageConfig {
  titleKey: string;
  descriptionKeys: string[];
}

export type ErrorCode = 403 | 404 | 500 | 503;

/**
 * Error message keys that map to localized messages in i18n files
 * The actual text values are stored in packages/i18n/messages/messages.*.json
 */
export const ERROR_MESSAGES: Record<ErrorCode, ErrorMessageConfig> = {
  403: {
    titleKey: 'error.403.title',
    descriptionKeys: ['error.403.description.1', 'error.403.description.2']
  },
  404: {
    titleKey: 'error.404.title',
    descriptionKeys: ['error.404.description.1']
  },
  500: {
    titleKey: 'error.500.title',
    descriptionKeys: ['error.500.description.1', 'error.500.description.2']
  },
  503: {
    titleKey: 'error.503.title',
    descriptionKeys: [
      'error.503.description.1',
      'error.503.description.2',
      'error.503.description.3'
    ]
  }
};
